module.exports = __webpack_public_path__ + "fonts/PingFangSC-Medium-simple.eb7ca673.woff2";